import {
    getItem,
    getList,
    patchItem,
    postItem
} from "./utils/entity-network-requests"

import { stakeholderBaseUrl } from "./utils/network-config"

const entityName = "stakeholder"

export const getStakeholderList = (token, parameters) =>
    getList(entityName, parameters, token, stakeholderBaseUrl)
export const getStakeholderItem = (token, id) =>
    getItem(entityName, id, token, undefined, stakeholderBaseUrl)
export const patchStakeholderItem = (token, id, stakeholder) =>
    patchItem(entityName, id, stakeholder, token, stakeholderBaseUrl)
export const postStakeholderItem = (token, stakeholder) =>
    postItem(entityName, stakeholder, token, stakeholderBaseUrl)
